import instance from "./BasebBrazeApi";

export const saveBrazeConfig = (data) => instance.post("config/", data);
export const getBrazeConfig = (organisationId) => instance.get("config/", {
  params: { organisation_id: organisationId },
});
export const deactivateBraze = (organisationId) => instance.delete("config/", {
  data: { organisation_id: organisationId },
});
export const syncBraze = (organisationId) => instance.post("sync/", {
  organisation_id: organisationId,
});
